<template>
  <h2> 404</h2>
  <router-link to="/" class="text-blue-500 hover:underline">
    Proceed to Home page
  </router-link>
</template>
